<div class="fullsize-vbox" style="gap: 5px;">
    <div class="toolbar-horizontal">
        <fluent-button (click)="onAddAccountsSheet(workbook)">+Accounts Sheet</fluent-button>
        <fluent-button (click)="onAddFormulaEvaluationSheet(workbook)"> +PY Sheet</fluent-button>
        <fluent-button (click)="onSendCurrentToPython(workbook)"> PY Send</fluent-button>
        <fluent-button (click)="onAutosizeColumns(workbook)"><i class="far fa-arrows-left-right-to-line"></i> </fluent-button>
        <fluent-button (click)="saveXlsx(workbook)"><i class="far fa-save"></i> </fluent-button>
        <div class="layout-hbox" style="border: 1px solid lightgray; border-radius: 5px; padding: 2px 5px">
            <input #fileInput type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
            <fluent-button (click)="loadXlsx(fileInput)">Load</fluent-button>
        </div>
    </div>
    <wj-flex-sheet #workbook style="flex: 1;"
                   (initialized)="initializeFlexSheet(workbook)">
        <wj-sheet [name]="'Scratchpad'" ></wj-sheet>
    </wj-flex-sheet>
</div>
